import { NotificationType } from '@/common/constants/common.constants';
import { ReplicationStatus } from '@/common/constants/replication.constants';
import i18n from '@/common/i18n';
import { useNotifications } from '@/common/utils/notifications/notificationsPlugin';

const getReplicationNotification = (status: ReplicationStatus, replicationIndex: number) => ({
  [ReplicationStatus.REPLICATING]: {
    type: NotificationType.INFO,
    title: i18n.t('Replication started'),
    message: i18n.t('New replication started')
  },
  [ReplicationStatus.REPLICATED]: {
    type: NotificationType.SUCCESS,
    title: i18n.t('Replication completed'),
    message: i18n.t('Replication #{num} successfully completed', { num: replicationIndex })
  },
  [ReplicationStatus.ERROR]: {
    type: NotificationType.ERROR,
    title: i18n.t('Replication failed'),
    message: i18n.t('Replication #{num} failed', { num: replicationIndex })
  },
  [ReplicationStatus.CANCELED]: {
    type: NotificationType.INFO,
    title: i18n.t('Replication canceled'),
    message: i18n.t('Replication #{num} canceled', { num: replicationIndex })
  }
}[status]);

export const notifyReplicationStatusChange = (
  status: ReplicationStatus | undefined,
  replicationId: string,
  replicationIndex: number
) => {
  if (!status) return;

  const notification = getReplicationNotification(status, replicationIndex);
  if (!notification) return;

  const { notify } = useNotifications();
  notify({
    type: notification.type,
    title: notification.title,
    message: notification.message,
    operationId: `replication-${status}-${replicationId}`,
    showBottom: true
  });
};
